const jaTestimonials = require('./ja.json');
const koTestimonials = require('./ko.json');

export {
  // eslint-disable-next-line import/prefer-default-export
  jaTestimonials,
  koTestimonials,
};
